export class ContactRole {
    isDeleted: boolean;
    id: number;
    role: string;
    userSupplierMapID: number;
}

export class SupplierContactMap {
    contactEmailId: string;
    entities: string[];
    supplierCode: string;
    supplierState: string;
    supplierName: string;
    vendorType: string;
    userRoles: ContactRole[];
    hasOnboardingTasks: boolean;
    allowedWorkflows: string[];
    isPrimaryContact: boolean;
    public hasRole(role: string): boolean {
        if (role && this.userRoles) {
            return this.userRoles.some(x => x.role.toLocaleLowerCase() === role.toLocaleLowerCase());
        }
        else {
            return false;
        }
    }
}

export class Contact {
    firstName: string;
    lastName: string;
    languageCode: string;
    emailId: string;
    jobtitle: string;
    phone: string;
    fax: string;
    mobile: string;
    supplierMaps: SupplierContactMap[];
}

export class UserDetails {
    isSupplier: boolean;
    isTeslaUser: boolean;
    isSIE: boolean;
    isGSM: boolean;
    supplierContact: Contact;
    isOptedForMFA: boolean;
}
